export default __webpack_public_path__ + "static/media/image3.ac6aa371.png";